import { Voucher } from "../interfaces/voucher";

export const DefaultAccountVoucherList = [
    'JAN25',
    'FEB25',
    'MAR25',
    'APR25',
    'MAY25',
    'JUN25',
    'JUL25',
    'AUG25',
    'SEP25',
    'OCT25',
    'NOV25',
    'DEC25'
];

export const PromoAccountVoucherList: Voucher[] = [
    // {
    //     voucherId: 'CNY2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-01-21',
    //     endDate: '2023-02-05',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'SMS',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1500,
    //     qty: 0,
    //     startDate: '2023-02-12',
    //     endDate: '2023-02-13',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Valentine2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 520,
    //     qty: 0,
    //     startDate: '2023-02-14',
    //     endDate: '2023-02-20',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'FebPayDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 300,
    //     qty: 0,
    //     startDate: '2023-02-25',
    //     endDate: '2023-02-28',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '03032023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-03-03',
    //     endDate: '2023-03-03',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'WomensDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 380,
    //     qty: 0,
    //     startDate: '2023-03-06',
    //     endDate: '2023-03-12',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MarPayDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 300,
    //     qty: 0,
    //     startDate: '2023-03-25',
    //     endDate: '2023-03-31',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '04042023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 800,
    //     qty: 0,
    //     startDate: '2023-04-04',
    //     endDate: '2023-04-04',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Easter23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 300,
    //     qty: 0,
    //     startDate: '2023-04-07',
    //     endDate: '2023-04-09',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Ramadan23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 500,
    //     qty: 0,
    //     startDate: '2023-04-14',
    //     endDate: '2023-04-28',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'LabourDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 550,
    //     qty: 0,
    //     startDate: '2023-05-01',
    //     endDate: '2023-05-01',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '05052023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-05-04',
    //     endDate: '2023-05-06',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MotherDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 800,
    //     qty: 0,
    //     startDate: '2023-05-11',
    //     endDate: '2023-05-15',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '5202023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 520,
    //     qty: 0,
    //     startDate: '2023-05-18',
    //     endDate: '2023-05-22',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MayPayDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 300,
    //     qty: 0,
    //     startDate: '2023-05-25',
    //     endDate: '2023-05-31',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '06062023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-06-03',
    //     endDate: '2023-06-09',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'FatherDay23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 880,
    //     qty: 0,
    //     startDate: '2023-06-13',
    //     endDate: '2023-06-19',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'DragonBoat23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 550,
    //     qty: 0,
    //     startDate: '2023-06-21',
    //     endDate: '2023-06-23',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Haji23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 660,
    //     qty: 0,
    //     startDate: '2023-06-25',
    //     endDate: '2023-06-30',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '07072023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 770,
    //     qty: 0,
    //     startDate: '2023-07-03',
    //     endDate: '2023-07-09',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MidYear2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-07-13',
    //     endDate: '2023-07-22',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Summer2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 550,
    //     qty: 0,
    //     startDate: '2023-07-24',
    //     endDate: '2023-07-31',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'SG58th',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 580,
    //     qty: 0,
    //     startDate: '2023-08-03',
    //     endDate: '2023-08-10',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'SurpriseAug23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-08-14',
    //     endDate: '2023-08-20',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Merdeka66th',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 660,
    //     qty: 0,
    //     startDate: '2023-08-24',
    //     endDate: '2023-08-31',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '09092023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 990,
    //     qty: 0,
    //     startDate: '2023-09-06',
    //     endDate: '2023-09-10',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MalaysiaDay2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 660,
    //     qty: 0,
    //     startDate: '2023-09-14',
    //     endDate: '2023-09-21',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'MidAutumn23',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 815,
    //     qty: 0,
    //     startDate: '2023-09-25',
    //     endDate: '2023-09-30',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '10102023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1010,
    //     qty: 0,
    //     startDate: '2023-10-05',
    //     endDate: '2023-10-11',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Halloween2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 880,
    //     qty: 0,
    //     startDate: '2023-10-25',
    //     endDate: '2023-10-31',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '11112023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-11-08',
    //     endDate: '2023-11-14',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'BlackFriday2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 550,
    //     qty: 0,
    //     startDate: '2023-11-24',
    //     endDate: '2023-11-30',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: '12122023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 1000,
    //     qty: 0,
    //     startDate: '2023-12-07',
    //     endDate: '2023-12-14',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    // {
    //     voucherId: 'Christmas2023',
    //     name: '',
    //     percent: 0.5,
    //     blastCredit: 550,
    //     qty: 0,
    //     startDate: '2023-12-19',
    //     endDate: '2023-12-26',
    //     enable: true,
    //     productType: 'account',
    //     productId: 'wedding_account_full',
    //     minQty: 1,
    //     maxQty: 0,
    //     qtyPerUser: 0,
    //     unlimited: true,
    //     disableReferral: false,
    //     currencyList: [],
    //     countryList: [],
    //     partnerId: '',
    // },
    {
        voucherId: 'Year2024',
        name: '',
        percent: 0.5,
        blastCredit: 550,
        qty: 0,
        startDate: '2024-01-01',
        endDate: '2024-01-10',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'JanPayDay24',
        name: '',
        percent: 0.5,
        blastCredit: 750,
        qty: 0,
        startDate: '2024-01-22',
        endDate: '2024-01-31',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'CNY2024',
        name: '',
        percent: 0.5,
        blastCredit: 880,
        qty: 0,
        startDate: '2024-02-05',
        endDate: '2024-02-15',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'FebPayDay24',
        name: '',
        percent: 0.5,
        blastCredit: 550,
        qty: 0,
        startDate: '2024-02-22',
        endDate: '2024-02-29',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'WomensDay2024',
        name: '',
        percent: 0.5,
        blastCredit: 380,
        qty: 0,
        startDate: '2024-03-04',
        endDate: '2024-03-10',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Ramadan2024',
        name: '',
        percent: 0.5,
        blastCredit: 750,
        qty: 0,
        startDate: '2024-03-12',
        endDate: '2024-03-26',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '04042024',
        name: '',
        percent: 0.5,
        blastCredit: 800,
        qty: 0,
        startDate: '2024-04-03',
        endDate: '2024-04-05',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Raya2024',
        name: '',
        percent: 0.5,
        blastCredit: 500,
        qty: 0,
        startDate: '2024-04-10',
        endDate: '2024-04-30',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'MothersDay2024',
        name: '',
        percent: 0.5,
        blastCredit: 800,
        qty: 0,
        startDate: '2024-05-03',
        endDate: '2024-05-13',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '5202024',
        name: '',
        percent: 0.5,
        blastCredit: 520,
        qty: 0,
        startDate: '2024-05-17',
        endDate: '2024-05-27',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '06062024',
        name: '',
        percent: 0.5,
        blastCredit: 660,
        qty: 0,
        startDate: '2024-06-03',
        endDate: '2024-06-09',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Haji2024',
        name: '',
        percent: 0.5,
        blastCredit: 660,
        qty: 0,
        startDate: '2024-06-13',
        endDate: '2024-06-30',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '07072024',
        name: '',
        percent: 0.5,
        blastCredit: 770,
        qty: 0,
        startDate: '2024-07-03',
        endDate: '2024-07-09',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'MidYearSale24',
        name: '',
        percent: 0.5,
        blastCredit: 1000,
        qty: 0,
        startDate: '2024-07-15',
        endDate: '2024-07-31',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'TogetherSG59',
        name: '',
        percent: 0.5,
        blastCredit: 590,
        qty: 0,
        startDate: '2024-08-03',
        endDate: '2024-08-10',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Merdeka67th',
        name: '',
        percent: 0.5,
        blastCredit: 670,
        qty: 0,
        startDate: '2024-08-17',
        endDate: '2024-08-31',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '09092024',
        name: '',
        percent: 0.5,
        blastCredit: 990,
        qty: 0,
        startDate: '2024-09-06',
        endDate: '2024-09-10',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'MalaysiaDay2024',
        name: '',
        percent: 0.5,
        blastCredit: 660,
        qty: 0,
        startDate: '2024-09-14',
        endDate: '2024-09-28',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '10102024',
        name: '',
        percent: 0.5,
        blastCredit: 1010,
        qty: 0,
        startDate: '2024-10-05',
        endDate: '2024-10-11',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Halloween2024',
        name: '',
        percent: 0.5,
        blastCredit: 880,
        qty: 0,
        startDate: '2024-10-19',
        endDate: '2024-10-31',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '11112024',
        name: '',
        percent: 0.5,
        blastCredit: 1000,
        qty: 0,
        startDate: '2024-11-08',
        endDate: '2024-11-14',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'BlackFriday2024',
        name: '',
        percent: 0.5,
        blastCredit: 550,
        qty: 0,
        startDate: '2024-11-24',
        endDate: '2024-11-30',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: '12122024',
        name: '',
        percent: 0.5,
        blastCredit: 1000,
        qty: 0,
        startDate: '2024-12-07',
        endDate: '2024-12-12',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    },
    {
        voucherId: 'Christmas2024',
        name: '',
        percent: 0.5,
        blastCredit: 550,
        qty: 0,
        startDate: '2024-12-19',
        endDate: '2024-12-26',
        enable: true,
        productType: 'account',
        productId: 'wedding_account_full',
        minQty: 1,
        maxQty: 0,
        qtyPerUser: 0,
        unlimited: true,
        disableReferral: false,
        currencyList: [],
        countryList: [],
        partnerId: '',
    }
]
